export enum LayoutFor {
  IN_ROUTE = 'in_route',
  DAMAGE_REGISTRATION = 'damage_registration',
  DAMAGE_DURING_ROUTE = 'damage_during_route',
}
